import { render } from "./AcademicCheckForm.vue?vue&type=template&id=37d9dbc0"
import script from "./AcademicCheckForm.vue?vue&type=script&lang=js"
export * from "./AcademicCheckForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__